import { render, staticRenderFns } from "./HeroPanel.vue?vue&type=template&id=db960256&"
import script from "./HeroPanel.vue?vue&type=script&lang=js&"
export * from "./HeroPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports